<template>
  <div style="height: 100%;width: 100%">
    <el-container style="height: 100%;width: 100%">
      <el-header height="20%"  class="padding">
        <div style="display: flex;flex-direction:row;margin-top: 50px;">
          <img style="width: 256px;height: 84px;margin-left: 10px;" src="/wall/空白.png">
          <div style="color: #2b8ad7;font-size: 80px;text-align:center;width: 100%">
            <div v-if="Object.keys(line).length !== 0">{{line.web_title}}</div>
            <div v-if="Object.keys(line).length !== 0">{{ line.line_name }}</div>
          </div>
          <div style="font-weight:bold;font-size: 35px;color: #2b8ad7;text-align:center;width: 300px">
            <div>{{ currentDate }}</div>
            <div>{{ currentTime }}</div>
            <div>{{currentWeek}}</div>
          </div>
        </div>
      </el-header>
      <el-main height="55%" class="padding">
        <el-row style="margin-top: 12%;text-align: center;" v-if="Object.keys(line).length !== 0">
          <el-col :span="12">
            <el-button class="btn_1" @click="upLine">{{ line.line_name }}上线</el-button>
          </el-col>
          <el-col :span="12">
            <el-button class="btn_2" @click="downLine">{{ line.line_name }}下线</el-button>
          </el-col>
        </el-row>
      </el-main>
      <el-footer height="25%" style="text-align: center" >
        <img style="height: 100%;width: 95%" src="/wall/空白.png" alt="">
      </el-footer>
    </el-container>
  </div>
  <el-dialog width="70%" title="上线登记" :lock-scroll="false" :close-on-click-modal="false" :before-close="closeUpLine" v-model="upLineStatus">
    <el-row>
      <el-col :span="4">
        <div class="workerCountTitleDiv">打卡总人数</div>
        <div class="workerCountContentDiv">{{clockInCount + clockOutCount}}</div>
      </el-col>
      <el-col :span="12">
        <h2 style="font-weight: bold;text-align: center;font-size: 35px;line-height: 80px">【请扫描工牌】</h2>
      </el-col>
      <el-col :span="4">
        <div class="workerCountTitleDiv">当前在线人数</div>
        <div class="workerCountContentDiv">{{clockInCount}}</div>
      </el-col>
      <el-col :span="4">
        <div class="workerCountTitleDiv1">当前下线人数</div>
        <div class="workerCountContentDiv1">{{clockOutCount}}</div>
      </el-col>
    </el-row>
    <el-table stripe border :header-cell-style="{textAlign: 'center', fontSize: '20px'}"
              :cell-style="{ textAlign: 'center', width: '100%', fontSize: '18px'}" style="overflow-y: auto;height: 400px" v-loading="clockInTableLoading" :data="clockInWorkList">
      <el-table-column prop="user_name" label="工号" min-width="160"/>
      <el-table-column prop="full_name" label="姓名" min-width="160"/>
      <el-table-column prop="clock_in_time" label="上线时间" min-width="200"/>
    </el-table>
  </el-dialog>

  <el-dialog width="70%" title="下线登记" :lock-scroll="false" :close-on-click-modal="false" :before-close="closeDownLine" v-model="downLineStatus">
    <el-row>
      <el-col :span="4">
        <div class="workerCountTitleDiv">打卡总人数</div>
        <div class="workerCountContentDiv">{{clockInCount + clockOutCount}}</div>
      </el-col>
      <el-col :span="12">
        <h2 style="font-weight: bold;text-align: center;font-size: 35px;line-height: 80px">【请扫描工牌】</h2>
      </el-col>
      <el-col :span="4">
        <div class="workerCountTitleDiv">当前在线人数</div>
        <div class="workerCountContentDiv">{{clockInCount}}</div>
      </el-col>
      <el-col :span="4">
        <div class="workerCountTitleDiv1">当前下线人数</div>
        <div class="workerCountContentDiv1">{{clockOutCount}}</div>
      </el-col>
    </el-row>
    <el-table stripe border :header-cell-style="{textAlign: 'center', fontSize: '20px'}"
              :cell-style="{ textAlign: 'center', width: '100%', fontSize: '18px'}" style="overflow-y: auto;height: 400px" v-loading="clockOutTableLoading" :data="clockOutWorkList">
      <el-table-column prop="user_name" style="font-size: 30px" label="工号" min-width="160"/>
      <el-table-column prop="full_name" label="姓名" min-width="160"/>
      <el-table-column prop="clock_in_time" label="上线时间" min-width="200"/>
      <el-table-column prop="clock_out_time" label="下线时间" min-width="200"/>
    </el-table>
  </el-dialog>
</template>

<script>

import {useDateFormat} from "@vueuse/core";

export default {
  name: "WorkCheckInPage",
  components: {},
  data() {
    return {
      line: {},
      currentDate: '',
      currentTime: '',
      currentWeek: '',
      scanName: '',
      upLineStatus: false,
      downLineStatus: false,
      clockInTableLoading: false,
      clockOutTableLoading: false,
      clockInWorkList: [],
      clockOutWorkList: [],
      clockInCount: 0,
      clockOutCount: 0,

      onlineTableData: [],
      onlinePeoples:0,
      offlineTableData: [],
      offlinePeoples:0,
      onlineVisible: false,
      offlineVisible: false,
      onlineTableLoading: false,
      offlineTableLoading:false,
    }
  },
  mounted() {
    // 在组件挂载后执行的生命周期钩子函数
    this.addKeyboardListener();
  },
  methods: {
    addKeyboardListener() {
      document.addEventListener('keydown', this.handleKeyDown);
    },
    removeKeyboardListener() {
      document.removeEventListener('keydown', this.handleKeyDown);
    },
    beforeDestroy() {
      this.removeKeyboardListener();
    },
    handleKeyDown(event) {
      if (event.keyCode === 13) {
        if (this.scanName.length !== 0) {
          if (this.upLineStatus) {
            this.clockIn();
          } else if (this.downLineStatus) {
            this.clockOut();
          } else {
            this.$message.error("请先选择扫码类型")
            this.scanName = '';
          }
        }
      } else if (event.keyCode !== 16) {
        this.scanName += event.key
      }
    },
    dateFormat() {
      this.currentDate = useDateFormat(new Date(), 'YYYY-MM-DD')
      this.currentTime = useDateFormat(new Date(), 'HH:mm:ss')
      this.currentWeek = useDateFormat(new Date(), 'dddd')
    },
    closeUpLine() {
      this.upLineStatus = false;
    },
    closeDownLine() {
      this.downLineStatus = false;
    },
    //点击上线按钮
    upLine() {
      this.upLineStatus = true;
      this.getClockRecordList("clockIn")
    },
    //点击下线按钮
    downLine() {
      this.downLineStatus = true;
      this.getClockRecordList("clockOut")
    },
    async clockIn() {
      let {data: res} = await this.$axios.post('workCheckIn/addClockInRecord', {
        userName: this.scanName,
        lineId: this.line.id,
      });
      if (res.code !== 0) {
        this.$message.error(res.message);
        this.scanName = ""
        return
      }
      this.$message.success(res.message);
      this.scanName = ""
      this.getClockRecordList("clockIn")
    },
    async clockOut() {
      let {data: res} = await this.$axios.post('workCheckIn/addClockOutRecord', {
        userName: this.scanName,
        lineId: this.line.id,
      });
      if (res.code !== 0) {
        this.$message.error(res.message);
        this.scanName = ""
        return
      }
      this.$message.success(res.message);
      this.scanName = ""
      this.getClockRecordList("clockOut")
    },
    async getClockRecordList(status) {
      if (status === "clockIn"){
        this.clockInTableLoading = true
      }else {
        this.clockOutTableLoading = true
      }
      let {data: res} = await this.$axios.post('workCheckIn/getClockRecordList', {
        clockStatus: status,
        lineId: this.line.id,
      });
      if (status === "clockIn"){
        this.clockInTableLoading = false
      }else {
        this.clockOutTableLoading = false
      }
      if (res.code !== 0) {
        this.$message.error(res.message);
        return
      }
      if (status === "clockIn"){
        this.clockInWorkList = res.data.workerRecordList
        this.clockInCount = res.data.userCount
      }else {
        this.clockOutWorkList = res.data.workerRecordList
        this.clockOutCount = res.data.userCount
      }
    },


    // getOnlineTableData() {
    //   this.$axios.get('tz/getOnlineTableData').then(response => {
    //     let res = response.data;
    //     if (res.code !== 0) {
    //       return this.$message.error("获取数据失败");
    //     }
    //
    //     this.onlineTableData = res.data;
    //     this.getOnlinePeoples();
    //   }, error => {
    //     this.$message.error(`页面数据加载失败` + error.message);
    //   })
    // },
    // getOnlinePeoples() {
    //   this.$axios.get('tz/getOnlinePeoples').then(response => {
    //     let res = response.data;
    //     if (res.code !== 0) {
    //       return this.$message.error("获取数据失败");
    //     }
    //
    //     this.onlinePeoples = res.data;
    //   }, error => {
    //     this.$message.error(`页面数据加载失败` + error.message);
    //   })
    // },
    // getOfflineTableData() {
    //   this.$axios.get('tz/getOfflineTableData').then(response => {
    //     let res = response.data;
    //     if (res.code !== 0) {
    //       return this.$message.error("获取数据失败");
    //     }
    //
    //     this.offlineTableData = res.data;
    //     this.getOfflinePeoples();
    //   }, error => {
    //     this.$message.error(`页面数据加载失败` + error.message);
    //   })
    // },
    // getOfflinePeoples() {
    //   this.$axios.get('tz/getOfflinePeoples').then(response => {
    //     let res = response.data;
    //     if (res.code !== 0) {
    //       return this.$message.error("获取数据失败");
    //     }
    //
    //     this.offlinePeoples = res.data;
    //   }, error => {
    //     this.$message.error(`页面数据加载失败` + error.message);
    //   })
    // },
    // addOnlineEmployees() {
    //   this.onlineTableLoading = true;
    //   this.$axios.post('tz/addOnlineEmployees', this.scanName).then(response => {
    //     this.onlineTableLoading = false;
    //     let res = response.data;
    //     if (res.code !== 0) {
    //       this.scanName = "";
    //       return this.$message.error(res.message);
    //     }
    //
    //     this.tableData = res.data;
    //     this.getOnlineTableData()
    //     this.scanName = '';
    //     this.$message.success("上线成功");
    //   }, error => {
    //     this.$message.error(`页面数据加载失败` + error.message);
    //     this.scanName = '';
    //   })
    // },
    // addOfflineEmployees() {
    //   this.offlineTableLoading = true;
    //   this.$axios.post('tz/addOfflineEmployees', this.scanName).then(response => {
    //     this.offlineTableLoading = false;
    //     let res = response.data;
    //     if (res.code !== 0) {
    //       this.scanName = "";
    //       return this.$message.error(res.message);
    //     }
    //
    //     this.offlineTableData = res.data;
    //     this.getOfflineTableData()
    //     this.$message.success("下线成功")
    //     this.scanName = '';
    //   }, error => {
    //     this.$message.error(`页面数据加载失败` + error.message);
    //     this.scanName = '';
    //   })
    // },
  },
  async created() {
    this.timer1 = setInterval(() => {
      this.dateFormat();
    }, 1000)
    let {data: res} = await this.$axios.get('workCheckIn/getLine?routeSuffix='+this.$route.params.key);
    if (res.code !== 0) {
      this.$message.error(res.message);
      return
    }
    this.line = res.data
    document.title = this.line.web_title + "-" + this.line.line_name
  }
}
</script>

<style scoped>
.padding {
  padding: 0;
}

.btn_1 {
  background-color: #2bd82f;
  color: white;
  height: 200px;
  font-size: 80px;
  border-radius: 20px;
}

.btn_2 {
  background-color: #0e91df;
  color: white;
  height: 200px;
  font-size: 80px;
  border-radius: 20px;
}
.workerCountTitleDiv{
  height: 40px;
  line-height: 40px;
  background-color: #2bd82f;
  color: #FFFFFF;
  font-weight: bold;
  text-align: center;
  font-size: 20px;
  border-radius: 15px 15px 0 0;
}
.workerCountContentDiv{
  height: 60px;
  line-height: 60px;
  color: #2bd82f;
  border-right: 2px solid #2bd82f;
  border-bottom: 2px solid #2bd82f;
  border-left: 2px solid #2bd82f;
  font-weight: bold;
  text-align: center;
  font-size: 30px;
  border-radius: 0 0 15px 15px ;
}

.workerCountTitleDiv1{
  height: 40px;
  line-height: 40px;
  background-color: #0e91df;
  color: #FFFFFF;
  font-weight: bold;
  text-align: center;
  font-size: 20px;
  border-radius: 15px 15px 0 0;
}
.workerCountContentDiv1{
  height: 60px;
  line-height: 60px;
  color: #0e91df;
  border-right: 2px solid #0e91df;
  border-bottom: 2px solid #0e91df;
  border-left: 2px solid #0e91df;
  font-weight: bold;
  text-align: center;
  font-size: 30px;
  border-radius: 0 0 15px 15px ;
}
</style>